import React from 'react';
import PropTypes from 'prop-types';

import Button, {
  ButtonSizeTypes,
  ButtonThemeTypes,
  ButtonType,
} from '@urbanmassage/component-library/lib/Button/Button';
import Cancel from '@urbanmassage/component-library/lib/Icons/Cancel/Cancel';

import 'spa/Components/Reviews/reviews-filters-sidebar.less';

const ReviewsFiltersSidebarLoadingState = ({onClose}) => (
  <React.Fragment>
    <div className="reviews-filters-sidebar__close-button-container">
      <Button
        onClick={onClose}
        size={ButtonSizeTypes.medium}
        theme={ButtonThemeTypes.grey}
        type={ButtonType.button}
      >
        <Cancel />
      </Button>
    </div>
    <div className="reviews-filters-sidebar__loading-title placeholder-box" />
    <div className="reviews-filters-sidebar__loading-element placeholder-box" />
    <div className="reviews-filters-sidebar__loading-element placeholder-box" />
    <div className="reviews-filters-sidebar__loading-element placeholder-box" />
    <div className="reviews-filters-sidebar__loading-spacer placeholder-box" />
    <div className="reviews-filters-sidebar__loading-element placeholder-box" />
    <div className="reviews-filters-sidebar__loading-element placeholder-box" />
    <div className="reviews-filters-sidebar__loading-element placeholder-box" />
    <div className="reviews-filters-sidebar__loading-element placeholder-box" />
  </React.Fragment>
);

ReviewsFiltersSidebarLoadingState.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default ReviewsFiltersSidebarLoadingState;



// WEBPACK FOOTER //
// ./spa/Components/Reviews/ReviewsFiltersSidebarLoadingState.jsx